import React from 'react'
import PropTypes from 'prop-types'
import { Col, Container, ListGroup } from 'reactstrap'
import faqData from './faqData'
import Accordion from '../../components/layout/Accordion/Accordion'
import Metatags from '../../components/shared/Metatags/Metatags'
import NewHeader from '../../components/layout/NewHeader/NewHeader'
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl'
import findIndex from 'lodash/findIndex'
import {
  Answer,
  Question,
  FaqCol,
  Category,
  ListGroupItem,
  Spacer,
  Categories,
  QuestionsSection,
  QuestionsRow,
  CategoriesRow,
  CategoryName,
  PageDescription
} from './FaqStyledComponents'

class Faq extends React.PureComponent {
  static propTypes = {
    match: PropTypes.object,
    location: PropTypes.object.isRequired,
    breadcrumb: PropTypes.string
  }

  constructor (props) {
    super(props)
    this.setActiveCategoryID = this.setActiveCategoryID.bind(this)
    this.state = {
      collapse: false,
      activeCategoryID: Number(props.match && props.match.params.jobID | 0),
      defaultIndex: 0
    }
  }

  componentDidMount () {
    this.scrollToSelectedSection()
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps (nextProps) {
    // If user select search result
    if (nextProps.location.state && nextProps.location.state.foundResult) {
      this.scrollToSelectedSection(nextProps.location.state.foundResult)
    }
  }

  scrollToSelectedSection (nextResult) {
    const { location } = this.props
    // If new result exist or result exist
    if (nextResult || (location.state && location.state.foundResult)) {
      const result = nextResult || location.state.foundResult
      const category = result.item.id.split('.')[1]
      const foundCategory =
        findIndex(faqData.list, ref => ref.id === category) || 0
      const foundQuestion = findIndex(
        faqData.list[foundCategory].questions,
        ref => ref.id === result.item.id
      )
      this.setState({
        activeCategoryID: foundCategory,
        defaultIndex: foundQuestion
      })
      setTimeout(
        () =>
          document.getElementById(result.item.id).scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          }),
        750
      )
    }
  }

  setActiveCategoryID (id) {
    id = Number(id)
    this.setState({ activeCategoryID: id })
  }

  render () {
    const activeCategoryID = this.state.activeCategoryID
    const activeCategory = faqData.list[activeCategoryID]
    const { defaultIndex } = this.state
    const listItems = faqData.list.map((item, index) => {
      const selected = activeCategoryID === index ? ' selected' : ''
      return [
        <ListGroupItem
          key={index}
          className={selected}
          onClick={e => this.setActiveCategoryID(index)}
        >
          <Category>
            {' '}
            {typeof item.category === 'string'
              ? item.category.toUpperCase()
              : item.category}
          </Category>
        </ListGroupItem>,
        <Metatags key='metatags' title='HausMart - the new retail! - FAQ' />
      ]
    })

    const questionList = activeCategory
      ? activeCategory.questions.map((item, index) => {
        return {
          id: item.id,
          header: (
            <Question key={`question_${index}`}>{item.question}</Question>
          ),
          content: <Answer key={`answer_${index}`}>{item.answer}</Answer>
        }
      })
      : []

    return (
      <React.Fragment>
        <NewHeader breadcrumbTitle={this.props.breadcrumb} opened>
          <h1 className='text-center'>
            {' '}
            <FormattedMessage id='faq.pageTitle' />
          </h1>
        </NewHeader>
        <FaqCol>
          <Categories>
            <CategoriesRow>
              <Col />
              <Col md='5'>
                <PageDescription>
                  <FormattedHTMLMessage id='faq.weHaveAnswers' />
                </PageDescription>
              </Col>
              <Col md='5'>
                <h2>
                  <FormattedMessage id='faq.categories' />
                </h2>
                <ListGroup>{listItems}</ListGroup>
              </Col>
              <Col />
            </CategoriesRow>
          </Categories>
          <QuestionsSection>
            <Container>
              <QuestionsRow>
                <Col md={{ size: '5', offset: 1 }}>
                  <CategoryName>
                    {activeCategory && activeCategory.category}
                  </CategoryName>
                  <Accordion items={questionList} openIndex={defaultIndex} />
                </Col>
                <Spacer md='5' />
              </QuestionsRow>
            </Container>
          </QuestionsSection>
        </FaqCol>
      </React.Fragment>
    )
  }
}

export default Faq
